import { render, staticRenderFns } from "./meta_recharge.vue?vue&type=template&id=487a6787&scoped=true&"
import script from "./meta_recharge.vue?vue&type=script&lang=js&"
export * from "./meta_recharge.vue?vue&type=script&lang=js&"
import style0 from "./meta_recharge.vue?vue&type=style&index=0&id=487a6787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a6787",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487a6787')) {
      api.createRecord('487a6787', component.options)
    } else {
      api.reload('487a6787', component.options)
    }
    module.hot.accept("./meta_recharge.vue?vue&type=template&id=487a6787&scoped=true&", function () {
      api.rerender('487a6787', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/meta_recharge.vue"
export default component.exports